import { ReviewCanvasContext } from 'modules/match-video/domain/interfaces';
import { Box, fillBlock, TextBlock } from 'modules/match-video/domain/scenes/kit';
import { NIGHT, shadowAlpha } from './style';

/** The wipe's clip grows 120 px past the tag (`inset(-120px -120px -120px 0)`), so a pulse around it shows. */
const WIPE_OVERSHOOT = 120;

/**
 * Clips to what the tag's wipe has revealed: from its left edge rightwards, `reveal` 0…1 of the tag plus the
 * overshoot, and the same overshoot above and below. `overflowHidden` — the tag also clips its own children (the gloss).
 */
export function clipTagWipe(ctx: ReviewCanvasContext, tag: Box, reveal: number, overflowHidden: boolean): void {
  const over = WIPE_OVERSHOOT * reveal;
  ctx.beginPath();
  ctx.rect(tag.left, tag.top - over, reveal * (tag.width + WIPE_OVERSHOOT), tag.height + 2 * over);
  ctx.clip();
  if (overflowHidden) {
    ctx.beginPath();
    ctx.rect(tag.left, tag.top, tag.width, tag.height);
    ctx.clip();
  }
}

/** The tag's colour block and its word, padded on the left by `padX`. */
export function drawTag(ctx: ReviewCanvasContext, tag: Box, text: TextBlock, padX: number, color: string): void {
  ctx.fillStyle = color;
  ctx.fillRect(tag.left, tag.top, tag.width, tag.height);
  ctx.fillStyle = NIGHT.ink;
  fillBlock(ctx, text, tag.left + padX, tag.top, 'left');
}

/**
 * Applies the body's `scaleX` from its left edge and paints the body with its drop shadow (`0 20px 50px`), then
 * leaves the transform on for its children. Returns `false` when the body is folded away — draw nothing of it then.
 */
export function beginBody(ctx: ReviewCanvasContext, body: Box, scaleX: number, fill: string | CanvasGradient): boolean {
  if (scaleX <= 0) return false;
  ctx.translate(body.left, 0);
  ctx.scale(scaleX, 1);
  ctx.translate(-body.left, 0);
  ctx.save();
  ctx.shadowColor = shadowAlpha(0.45);
  ctx.shadowBlur = 50;
  ctx.shadowOffsetY = 20;
  ctx.fillStyle = fill;
  ctx.fillRect(body.left, body.top, body.width, body.height);
  ctx.restore();
  return true;
}
